// source: tableau/metrics/models/threshold.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return window;
}.call(null));

var tableau_metrics_models_duration_pb = require('../../../tableau/metrics/models/duration_pb.js');
goog.object.extend(proto, tableau_metrics_models_duration_pb);
goog.exportSymbol('proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.SimpleStatus', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.StaticValueThresholdType', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.StaticValueThresholdValue', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.StaticValueThresholdValue.ValueCase', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.Threshold', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.Threshold.TypeCase', null, global);
goog.exportSymbol('proto.tableau.metrics.models.p4.ThresholdStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.Threshold = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tableau.metrics.models.p4.Threshold.oneofGroups_);
};
goog.inherits(proto.tableau.metrics.models.p4.Threshold, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.Threshold.displayName = 'proto.tableau.metrics.models.p4.Threshold';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.displayName = 'proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.SimpleStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.SimpleStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.SimpleStatus.displayName = 'proto.tableau.metrics.models.p4.SimpleStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.tableau.metrics.models.p4.StaticValueThresholdType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.StaticValueThresholdType.displayName = 'proto.tableau.metrics.models.p4.StaticValueThresholdType';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.tableau.metrics.models.p4.StaticValueThresholdValue.oneofGroups_);
};
goog.inherits(proto.tableau.metrics.models.p4.StaticValueThresholdValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.tableau.metrics.models.p4.StaticValueThresholdValue.displayName = 'proto.tableau.metrics.models.p4.StaticValueThresholdValue';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tableau.metrics.models.p4.Threshold.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.Threshold.TypeCase = {
  TYPE_NOT_SET: 0,
  TYPE_NUMBER_OF_PERIODS: 2,
  TYPE_STATIC_VALUE: 3
};

/**
 * @return {proto.tableau.metrics.models.p4.Threshold.TypeCase}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.getTypeCase = function() {
  return /** @type {proto.tableau.metrics.models.p4.Threshold.TypeCase} */(jspb.Message.computeOneofCase(this, proto.tableau.metrics.models.p4.Threshold.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.Threshold.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.Threshold} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.Threshold.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    typeNumberOfPeriods: (f = msg.getTypeNumberOfPeriods()) && proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.toObject(includeInstance, f),
    typeStaticValue: (f = msg.getTypeStaticValue()) && proto.tableau.metrics.models.p4.StaticValueThresholdType.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.Threshold}
 */
proto.tableau.metrics.models.p4.Threshold.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.Threshold;
  return proto.tableau.metrics.models.p4.Threshold.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.Threshold} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.Threshold}
 */
proto.tableau.metrics.models.p4.Threshold.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = new proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType;
      reader.readMessage(value,proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.deserializeBinaryFromReader);
      msg.setTypeNumberOfPeriods(value);
      break;
    case 3:
      var value = new proto.tableau.metrics.models.p4.StaticValueThresholdType;
      reader.readMessage(value,proto.tableau.metrics.models.p4.StaticValueThresholdType.deserializeBinaryFromReader);
      msg.setTypeStaticValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.Threshold.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.Threshold} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.Threshold.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTypeNumberOfPeriods();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.serializeBinaryToWriter
    );
  }
  f = message.getTypeStaticValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.tableau.metrics.models.p4.StaticValueThresholdType.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.tableau.metrics.models.p4.Threshold} returns this
 */
proto.tableau.metrics.models.p4.Threshold.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NumberOfPeriodsThresholdType type_number_of_periods = 2;
 * @return {?proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.getTypeNumberOfPeriods = function() {
  return /** @type{?proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType, 2));
};


/**
 * @param {?proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType|undefined} value
 * @return {!proto.tableau.metrics.models.p4.Threshold} returns this
*/
proto.tableau.metrics.models.p4.Threshold.prototype.setTypeNumberOfPeriods = function(value) {
  return jspb.Message.setOneofWrapperField(this, 2, proto.tableau.metrics.models.p4.Threshold.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.Threshold} returns this
 */
proto.tableau.metrics.models.p4.Threshold.prototype.clearTypeNumberOfPeriods = function() {
  return this.setTypeNumberOfPeriods(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.hasTypeNumberOfPeriods = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional StaticValueThresholdType type_static_value = 3;
 * @return {?proto.tableau.metrics.models.p4.StaticValueThresholdType}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.getTypeStaticValue = function() {
  return /** @type{?proto.tableau.metrics.models.p4.StaticValueThresholdType} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.StaticValueThresholdType, 3));
};


/**
 * @param {?proto.tableau.metrics.models.p4.StaticValueThresholdType|undefined} value
 * @return {!proto.tableau.metrics.models.p4.Threshold} returns this
*/
proto.tableau.metrics.models.p4.Threshold.prototype.setTypeStaticValue = function(value) {
  return jspb.Message.setOneofWrapperField(this, 3, proto.tableau.metrics.models.p4.Threshold.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.Threshold} returns this
 */
proto.tableau.metrics.models.p4.Threshold.prototype.clearTypeStaticValue = function() {
  return this.setTypeStaticValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.Threshold.prototype.hasTypeStaticValue = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.toObject = function(includeInstance, msg) {
  var f, obj = {
    duration: (f = msg.getDuration()) && tableau_metrics_models_duration_pb.Duration.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && proto.tableau.metrics.models.p4.SimpleStatus.toObject(includeInstance, f),
    showComparisonLine: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType;
  return proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new tableau_metrics_models_duration_pb.Duration;
      reader.readMessage(value,tableau_metrics_models_duration_pb.Duration.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    case 2:
      var value = new proto.tableau.metrics.models.p4.SimpleStatus;
      reader.readMessage(value,proto.tableau.metrics.models.p4.SimpleStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowComparisonLine(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      tableau_metrics_models_duration_pb.Duration.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tableau.metrics.models.p4.SimpleStatus.serializeBinaryToWriter
    );
  }
  f = message.getShowComparisonLine();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional Duration duration = 1;
 * @return {?proto.tableau.metrics.models.p4.Duration}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.getDuration = function() {
  return /** @type{?proto.tableau.metrics.models.p4.Duration} */ (
    jspb.Message.getWrapperField(this, tableau_metrics_models_duration_pb.Duration, 1));
};


/**
 * @param {?proto.tableau.metrics.models.p4.Duration|undefined} value
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} returns this
*/
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} returns this
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SimpleStatus status = 2;
 * @return {?proto.tableau.metrics.models.p4.SimpleStatus}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.getStatus = function() {
  return /** @type{?proto.tableau.metrics.models.p4.SimpleStatus} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.SimpleStatus, 2));
};


/**
 * @param {?proto.tableau.metrics.models.p4.SimpleStatus|undefined} value
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} returns this
*/
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} returns this
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool show_comparison_line = 3;
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.getShowComparisonLine = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType} returns this
 */
proto.tableau.metrics.models.p4.NumberOfPeriodsThresholdType.prototype.setShowComparisonLine = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.SimpleStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.SimpleStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.SimpleStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
    undefined: jspb.Message.getFieldWithDefault(msg, 1, 0),
    above: jspb.Message.getFieldWithDefault(msg, 2, 0),
    equal: jspb.Message.getFieldWithDefault(msg, 3, 0),
    below: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.SimpleStatus;
  return proto.tableau.metrics.models.p4.SimpleStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.SimpleStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (reader.readEnum());
      msg.setUndefined(value);
      break;
    case 2:
      var value = /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (reader.readEnum());
      msg.setAbove(value);
      break;
    case 3:
      var value = /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (reader.readEnum());
      msg.setEqual(value);
      break;
    case 4:
      var value = /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (reader.readEnum());
      msg.setBelow(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.SimpleStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.SimpleStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.SimpleStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUndefined();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getAbove();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getEqual();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getBelow();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional ThresholdStatus undefined = 1;
 * @return {!proto.tableau.metrics.models.p4.ThresholdStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.getUndefined = function() {
  return /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.tableau.metrics.models.p4.ThresholdStatus} value
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus} returns this
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.setUndefined = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ThresholdStatus above = 2;
 * @return {!proto.tableau.metrics.models.p4.ThresholdStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.getAbove = function() {
  return /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.tableau.metrics.models.p4.ThresholdStatus} value
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus} returns this
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.setAbove = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ThresholdStatus equal = 3;
 * @return {!proto.tableau.metrics.models.p4.ThresholdStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.getEqual = function() {
  return /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.tableau.metrics.models.p4.ThresholdStatus} value
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus} returns this
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.setEqual = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ThresholdStatus below = 4;
 * @return {!proto.tableau.metrics.models.p4.ThresholdStatus}
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.getBelow = function() {
  return /** @type {!proto.tableau.metrics.models.p4.ThresholdStatus} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.tableau.metrics.models.p4.ThresholdStatus} value
 * @return {!proto.tableau.metrics.models.p4.SimpleStatus} returns this
 */
proto.tableau.metrics.models.p4.SimpleStatus.prototype.setBelow = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.StaticValueThresholdType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: (f = msg.getValue()) && proto.tableau.metrics.models.p4.StaticValueThresholdValue.toObject(includeInstance, f),
    status: (f = msg.getStatus()) && proto.tableau.metrics.models.p4.SimpleStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.StaticValueThresholdType;
  return proto.tableau.metrics.models.p4.StaticValueThresholdType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.tableau.metrics.models.p4.StaticValueThresholdValue;
      reader.readMessage(value,proto.tableau.metrics.models.p4.StaticValueThresholdValue.deserializeBinaryFromReader);
      msg.setValue(value);
      break;
    case 2:
      var value = new proto.tableau.metrics.models.p4.SimpleStatus;
      reader.readMessage(value,proto.tableau.metrics.models.p4.SimpleStatus.deserializeBinaryFromReader);
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.StaticValueThresholdType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.tableau.metrics.models.p4.StaticValueThresholdValue.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.tableau.metrics.models.p4.SimpleStatus.serializeBinaryToWriter
    );
  }
};


/**
 * optional StaticValueThresholdValue value = 1;
 * @return {?proto.tableau.metrics.models.p4.StaticValueThresholdValue}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.getValue = function() {
  return /** @type{?proto.tableau.metrics.models.p4.StaticValueThresholdValue} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.StaticValueThresholdValue, 1));
};


/**
 * @param {?proto.tableau.metrics.models.p4.StaticValueThresholdValue|undefined} value
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType} returns this
*/
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.setValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType} returns this
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.clearValue = function() {
  return this.setValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.hasValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SimpleStatus status = 2;
 * @return {?proto.tableau.metrics.models.p4.SimpleStatus}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.getStatus = function() {
  return /** @type{?proto.tableau.metrics.models.p4.SimpleStatus} */ (
    jspb.Message.getWrapperField(this, proto.tableau.metrics.models.p4.SimpleStatus, 2));
};


/**
 * @param {?proto.tableau.metrics.models.p4.SimpleStatus|undefined} value
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType} returns this
*/
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.setStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdType} returns this
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.clearStatus = function() {
  return this.setStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdType.prototype.hasStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.oneofGroups_ = [[1]];

/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.ValueCase = {
  VALUE_NOT_SET: 0,
  DOUBLE_VALUE: 1
};

/**
 * @return {proto.tableau.metrics.models.p4.StaticValueThresholdValue.ValueCase}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.getValueCase = function() {
  return /** @type {proto.tableau.metrics.models.p4.StaticValueThresholdValue.ValueCase} */(jspb.Message.computeOneofCase(this, proto.tableau.metrics.models.p4.StaticValueThresholdValue.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.toObject = function(opt_includeInstance) {
  return proto.tableau.metrics.models.p4.StaticValueThresholdValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.toObject = function(includeInstance, msg) {
  var f, obj = {
    doubleValue: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdValue}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.tableau.metrics.models.p4.StaticValueThresholdValue;
  return proto.tableau.metrics.models.p4.StaticValueThresholdValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdValue}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDoubleValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.tableau.metrics.models.p4.StaticValueThresholdValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.tableau.metrics.models.p4.StaticValueThresholdValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double double_value = 1;
 * @return {number}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.getDoubleValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdValue} returns this
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.setDoubleValue = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.tableau.metrics.models.p4.StaticValueThresholdValue.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.tableau.metrics.models.p4.StaticValueThresholdValue} returns this
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.clearDoubleValue = function() {
  return jspb.Message.setOneofField(this, 1, proto.tableau.metrics.models.p4.StaticValueThresholdValue.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.tableau.metrics.models.p4.StaticValueThresholdValue.prototype.hasDoubleValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.tableau.metrics.models.p4.ThresholdStatus = {
  THRESHOLD_STATUS_UNSPECIFIED: 0,
  THRESHOLD_STATUS_NEUTRAL: 1,
  THRESHOLD_STATUS_GOOD: 2,
  THRESHOLD_STATUS_BAD: 3
};

goog.object.extend(exports, proto.tableau.metrics.models.p4);
